import { api, unwrap } from './client';
import { userFromApi, createUserToApi, updateUserToApi } from './_transforms';

const PAGE_SIZE = 500;

export async function listUsers({ page = 0, size = PAGE_SIZE, sort = 'createdAt,desc', q } = {}) {
  const params = { page, size, sort };
  if (q) params.q = q;
  const data = await unwrap(api.get('/api/users', { params }));
  return {
    content: (data.content || []).map(userFromApi),
    totalElements: data.totalElements,
    totalPages: data.totalPages,
    number: data.number,
  };
}

export async function getUser(id) {
  const data = await unwrap(api.get(`/api/users/${id}`));
  return userFromApi(data);
}

export async function createUser(payload) {
  const data = await unwrap(api.post('/api/users', createUserToApi(payload)));
  return userFromApi(data);
}

export async function updateUser(id, payload) {
  const data = await unwrap(api.put(`/api/users/${id}`, updateUserToApi(payload)));
  return userFromApi(data);
}

export async function activateUser(id) {
  const data = await unwrap(api.post(`/api/users/${id}/activate`));
  return userFromApi(data);
}

export async function deactivateUser(id) {
  const data = await unwrap(api.post(`/api/users/${id}/deactivate`));
  return userFromApi(data);
}
